import { gql } from "@apollo/client"

export const UPDATE_STATION_DISTANCE_CONFIG = gql`
    mutation updateStationDistanceConfig($station_distance_id: NonEmptyString!, $station_distance_config: StationDistanceConfigInput!) {
        updateStationDistanceConfig(station_distance_id: $station_distance_id, station_distance_config: $station_distance_config) {
            code
            success
            message
        }
    }
`;

export const CREATE_STATION_DISTANCE_CONFIG = gql`
    mutation createStationDistanceConfig($station_distance_config: StationDistanceConfigInput!) {
        createStationDistanceConfig(station_distance_config: $station_distance_config) {
            code
            success
            message
        }
    }
`;